import React from 'react'
import './New6.css';

const New6 = () => {
  return (
    <div className='back3'>
      <h1>CloudSplore</h1>
    <h5>The Cloud Computing Cell has conducted a workshop from 28th to 29th April 2022 titled as “CloudSplore” . The workshop was conducted under the guidance of Dr. Parneet Kaur and Dr. Abhilasha Singh Coordinators Cloud Cell.

The Cloud Computing cell has been in successful execution for more than 6 years and has bookmarked itself as the one of the prestigious technical societies of AKGEC, IT Department. In order to continue the trends of the effective learning and capturing intelligent minds to serve the college in even bigger and better way, it is necessary to organize events which help students to gain extra knowledge and sharpen their technical skills. Thus, in this series another workshop Cloudsplore was conducted by the cell on 28th and 29th April 2022. This event was open to all first- and second-year students, 140 students were registered for this Workshop.
The workshop was carried out in following manner:

1. Round 1: This Round was conducted in 2 days in which we explained the cloud and its application along with Hands-On-Experience on Virtual Machine creation on AWS and GitHub to all the participants. This round was held at Web technology lab, IT lab 1 and IT lab 2 on 28th and 29th April at 4 PM.

2. Round 2: This Round was consisted of quiz based on cloud and it`s services such as Virtual Machine creation and GitHub questions which was self-paced to access the basic technical and IQ of the students. The students were shortlisted on the basis of their marks for this round. This round was held online at D2C Platform on 30th April 2022 at 7:00 PM.</h5>
    
  </div>
   )
}

export default New6 ;
